'use strict';

angular.module('commerce')
    .component('licenseInfo', {
        templateUrl: 'js/modules/commerce/components/license-info/template.html',
        controller: ['gettext', function(gettext) {
            var vm = this;

            gettext('Activo');
            gettext('Desactivado');

            vm.hasExtras = false;
            vm.$onInit = function() {
                vm.hasExtras = vm.license.features.randomization
                    || vm.license.features.randomizationStockage
                    || vm.license.features.epro
                    || vm.license.features.encryption
                    || vm.license.features.advancedReports
                    || vm.license.features.medicalCoding
                ;
            }
        }],
        bindings: {
            license: '<',
        },
    });
